import { ContentCard } from 'apps/dashboard/shared/scripts/components';
import { Invoice } from 'apps/shared/scripts/__generated__/graphql.generated';

import InvoiceBanner from './InvoiceBanner';
import InvoiceBody from './InvoiceBody';
import InvoiceFooter from './InvoiceFooter';
import InvoiceHeader from './InvoiceHeader';

type Props = Invoice;

const InvoiceDetails = ({
  currencyCode,
  customer,
  id,
  invoiceNumber,
  item,
  payment,
  totals,
  transactionTimestamp,
}: Props) => {
  return (
    <ContentCard noPadding noBorder>
      <InvoiceHeader id={id} invoiceNumber={invoiceNumber} />
      <InvoiceBanner
        totals={totals}
        transactionTimestamp={transactionTimestamp}
      />
      <InvoiceBody
        currencyCode={currencyCode}
        customer={customer}
        item={item}
        payment={payment}
      />
      <InvoiceFooter />
    </ContentCard>
  );
};

InvoiceDetails.displayName = 'InvoiceDetails';

export default InvoiceDetails;
